const useGetCodeError = () => {
  const getCodeError = (error: any) => {
    if (error?.response) {
      return error?.response?.data?.code;
    }
    return error.message;
  };

  return getCodeError;
};

export default useGetCodeError;
